import makeActionCreator from 'src/lib/makeActionCreator';
import { State } from 'src/redux/reducers/RootReducer';
import {
  getNotificationsData, postNotificationData, putNotificationData,
} from 'src/apis/NotificationAPI';
import { setFormStatus } from 'src/redux/actions/formActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import {
  NotificationContact, NotificationModel,
} from 'src/models/NotificationModel';
import { setAlert } from 'src/redux/actions/alertActions';
import { ALERT_TYPE } from 'src/constants/AlertType';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';

export const setNotificationsData = makeActionCreator(SET_NOTIFICATIONS);

const mapContacts = (contacts: NotificationContact[]) => contacts.map((contact) => ({
  email: contact.email || null,
  phone: contact.phone || null,
}));

export const getNotificationsAction: () => ThunkedAction<State> =
() => async (dispatch: any, getState: any) => {
  try {
    dispatch(setFormStatus({ [FORM.get_notifications]: FORM_STATUS.loading }));
    const organisation = getState().currentOrganisation.id;
    const response = await getNotificationsData(organisation);
    if (response.success) {
      dispatch(setNotificationsData(response.data));
      dispatch(setFormStatus({ [FORM.get_notifications]: FORM_STATUS.success }));
    } else {
      dispatch(setFormStatus({ [FORM.get_notifications]: FORM_STATUS.error }));
    }
  } catch (e) { /* Log the error here */
    dispatch(setFormStatus({ [FORM.get_notifications]: FORM_STATUS.error }));
  }
};

export const saveNotificationAction: (
  notification: NotificationModel | null,
  contacts: NotificationContact[],
  notificationType: string,
) => ThunkedAction<State> =
  (notification, contacts, notificationType) => async (dispatch: any, getState: any) => {
    dispatch(setFormStatus({ [FORM.save_notification]: FORM_STATUS.processing }));
    try {
      const organisation = getState().currentOrganisation.id;
      const payload = {
        type: notification?.type ?? notificationType,
        contacts: mapContacts(contacts),
      };
      const notificationId = notification?.id;
      const response = notificationId
        ? await putNotificationData(organisation, { ...payload, id: notificationId })
        : await postNotificationData(organisation, payload);
      if (response.success) {
        dispatch(getNotificationsAction());
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          code: 'messages.notification_saved',
        }));
        dispatch(setFormStatus({ [FORM.save_notification]: FORM_STATUS.success }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        code: 'messages.notification_saved_error',
      }));
      dispatch(setFormStatus({ [FORM.save_notification]: FORM_STATUS.error }));
    } catch (e) { /* Log the error here */
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        code: 'messages.notification_saved_error',
      }));
      dispatch(setFormStatus({ [FORM.save_notification]: FORM_STATUS.error }));
    }
  };

export const deleteNotificationContactAction: (
  notification: NotificationModel,
  contact: NotificationContact,
) => ThunkedAction<State> =
  (notification, contact) => async (dispatch: any, getState: any) => {
    dispatch(setFormStatus({ [FORM.delete_notification_contact]: FORM_STATUS.processing }));
    try {
      const organisation = getState().currentOrganisation.id;
      const contacts = notification.contacts.filter((item) => item.id !== contact.id);
      const payload = {
        type: notification.type,
        contacts: mapContacts(contacts),
      };
      const response = await putNotificationData(organisation, { ...payload, id: notification.id });
      if (response.success) {
        dispatch(getNotificationsAction());
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          code: 'messages.deleted_notification_contact',
        }));
        dispatch(setFormStatus({ [FORM.delete_notification_contact]: FORM_STATUS.success }));
        dispatch(closeDialog({ dialog: DIALOGS.deleteNotificationContact }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        code: 'messages.deleted_notification_contact_error',
      }));
      dispatch(setFormStatus({ [FORM.delete_notification_contact]: FORM_STATUS.error }));
      dispatch(closeDialog({ dialog: DIALOGS.deleteNotificationContact }));
    } catch (e) { /* Log the error here */
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        code: 'messages.deleted_notification_contact_error',
      }));
      dispatch(setFormStatus({ [FORM.delete_notification_contact]: FORM_STATUS.error }));
      dispatch(closeDialog({ dialog: DIALOGS.deleteNotificationContact }));
    }
  };
